import { createIcon } from '@chakra-ui/react';

/**
 * Icons exported from the schedules Figma file (W08 < Schedules >). Kept together
 * here rather than in ~components/ui/icons because they only exist for the
 * scheduler timeline and its legend.
 */

const defaultProps = {
  fill: 'none',
  height: '6',
  width: '6',
};

/** Legend icon for DEFAULT_INPUT_SOURCE. */
export const ScheduleDefaultInputSourceIcon = createIcon({
  displayName: 'ScheduleDefaultInputSourceIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M16.0391 3.95508C18.9789 5.43386 20.9999 8.48039 21 12C20.9999 16.9705 16.9705 21 12 21C7.0295 21 3.00011 16.9705 3 12C3.00009 8.48039 5.02108 5.43386 7.96094 3.95508L8.85938 5.74219C6.56848 6.89454 5.00009 9.26513 5 12C5.00011 15.8659 8.13407 19 12 19C15.8659 19 18.9999 15.8659 19 12C18.9999 9.26513 17.4315 6.89454 15.1406 5.74219L16.0391 3.95508ZM13 13H11V2H13V13Z"
      fill="currentColor"
    />
  ),
});

/** Timeline-block icon for DEFAULT_INPUT_SOURCE. */
export const ScheduleInputIcon = createIcon({
  displayName: 'ScheduleInputIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M15 12L11 8V11H3V13H11V16M21 18V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V9H7V6H19V18H7V15H5V18C5 18.5304 5.21071 19.0391 5.58579 19.4142C5.96086 19.7893 6.46957 20 7 20H19C19.5304 20 20.0391 19.7893 20.4142 19.4142C20.7893 19.0391 21 18.5304 21 18Z"
      fill="currentColor"
    />
  ),
});

/** APPS, used both in the legend and on the timeline. */
export const ScheduleAppsIcon = createIcon({
  displayName: 'ScheduleAppsIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <>
      <path
        d="M4 19C4 19.5523 4.44771 20 5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44771 18 4 18.4477 4 19Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M18 19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M4 12C4 12.5523 4.44771 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44771 11 4 11.4477 4 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M4 5C4 5.55228 4.44772 6 5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M18 5C18 5.55229 18.4477 6 19 6C19.5523 6 20 5.55229 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </>
  ),
});

/** BOOKMARK, used both in the legend and on the timeline. */
export const ScheduleBookmarkIcon = createIcon({
  displayName: 'ScheduleBookmarkIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M12 2C12.0632 2 12.1261 2.00091 12.1885 2.00391C17.6243 2.10441 22 6.54013 22 12C22 17.4599 17.6243 21.8946 12.1885 21.9951C12.1261 21.9981 12.0633 22 12 22C11.9364 22 11.8733 21.9981 11.8105 21.9951C6.37515 21.8941 2 17.4595 2 12C2 6.54046 6.37515 2.10492 11.8105 2.00391C11.8733 2.00088 11.9364 2 12 2ZM11 17.0322C10.3151 17.0771 9.66062 17.1678 9.0459 17.2959C9.13884 17.4994 9.23653 17.6937 9.33887 17.8779C9.85503 18.807 10.432 19.4029 11 19.7197V17.0322ZM13 19.7197C13.568 19.4029 14.145 18.807 14.6611 17.8779C14.7634 17.6938 14.8602 17.4993 14.9531 17.2959C14.3387 17.1679 13.6846 17.0771 13 17.0322V19.7197ZM7.11426 17.8711C6.98776 17.9218 6.86433 17.9741 6.74414 18.0283C6.96721 18.223 7.20051 18.4059 7.44434 18.5752C7.32787 18.3491 7.21798 18.1141 7.11426 17.8711ZM16.8848 17.8711C16.781 18.1141 16.6712 18.3491 16.5547 18.5752C16.7986 18.406 17.0318 18.223 17.2549 18.0283C17.1347 17.9741 17.0113 17.9218 16.8848 17.8711ZM4.06445 13C4.2236 14.2759 4.68117 15.4584 5.36816 16.4746C5.71825 16.2915 6.08863 16.1214 6.47852 15.9697C6.24355 15.0402 6.08947 14.0411 6.0293 13H4.06445ZM17.9707 13C17.9105 14.0412 17.7555 15.0401 17.5205 15.9697C17.9104 16.1214 18.2807 16.2915 18.6309 16.4746C19.318 15.4583 19.7764 14.2761 19.9355 13H17.9707ZM8.03418 13C8.08979 13.8485 8.21424 14.6514 8.39551 15.3906C9.22074 15.2046 10.0952 15.0816 11 15.0293V13H8.03418ZM13 15.0293C13.9045 15.0816 14.7786 15.2047 15.6035 15.3906C15.7848 14.6513 15.9102 13.8485 15.9658 13H13V15.0293ZM5.36816 7.52344C4.68066 8.53995 4.22367 9.72357 4.06445 11H6.0293C6.08951 9.95824 6.24329 8.95836 6.47852 8.02832C6.08862 7.87651 5.71826 7.70666 5.36816 7.52344ZM8.39551 8.6084C8.21412 9.34787 8.08981 10.1512 8.03418 11H11V8.96973C10.0951 8.91733 9.22077 8.79462 8.39551 8.6084ZM15.6035 8.6084C14.7785 8.7945 13.9045 8.91735 13 8.96973V11H15.9658C15.9102 10.1511 15.7849 9.34793 15.6035 8.6084ZM18.6309 7.52344C18.2807 7.70664 17.9104 7.87653 17.5205 8.02832C17.7558 8.95843 17.9105 9.95815 17.9707 11H19.9355C19.7763 9.72338 19.3185 8.54005 18.6309 7.52344ZM11 4.2793C10.4318 4.59603 9.85516 5.19275 9.33887 6.12207C9.23666 6.30605 9.13873 6.49993 9.0459 6.70312C9.66068 6.83124 10.315 6.92193 11 6.9668V4.2793ZM13 6.9668C13.6847 6.92196 14.3386 6.83114 14.9531 6.70312C14.8603 6.50006 14.7633 6.30594 14.6611 6.12207C14.1448 5.19275 13.5682 4.59603 13 4.2793V6.9668ZM7.44434 5.42383C7.20032 5.59319 6.96639 5.77591 6.74316 5.9707C6.86346 6.02497 6.98666 6.07816 7.11328 6.12891C7.21717 5.88551 7.32766 5.65029 7.44434 5.42383ZM16.5547 5.42383C16.6714 5.6503 16.7818 5.88549 16.8857 6.12891C17.0124 6.07817 17.1356 6.02496 17.2559 5.9707C17.0326 5.77592 16.7987 5.59318 16.5547 5.42383Z"
      fill="currentColor"
    />
  ),
});

/** Legend icon for SOURCE. */
export const ScheduleSourceIcon = createIcon({
  displayName: 'ScheduleSourceIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M15.1925 8.54309C17.0414 10.392 17.0545 13.4016 15.2003 15.256L9.35657 21.1007C7.50217 22.9551 4.49173 22.9419 2.6427 21.0929C0.793671 19.2439 0.780492 16.2334 2.63489 14.379L5.22083 11.7931L6.63587 13.2072L5.92883 13.9142L4.04895 15.7931C2.98097 16.8611 2.9834 18.6055 4.05676 19.6788C5.12999 20.752 6.87351 20.7542 7.94153 19.6866L13.7863 13.8419C14.854 12.7739 14.8517 11.0304 13.7784 9.95715L13.0714 9.25012L14.4855 7.83606L15.1925 8.54309ZM14.4786 2.63489C16.333 0.7805 19.3435 0.793729 21.1925 2.6427C23.0415 4.49174 23.0547 7.50216 21.2003 9.35657L18.6144 11.9425L17.1993 10.5284L17.9064 9.82141L19.7863 7.94251C20.8542 6.87451 20.8518 5.13013 19.7784 4.05676C18.7052 2.9836 16.9617 2.98139 15.8937 4.04895L10.049 9.89368C8.9813 10.9617 8.98357 12.7052 10.0568 13.7784L10.7638 14.4855L9.34973 15.8995L8.6427 15.1925C6.79383 13.3436 6.78082 10.334 8.63489 8.47962L14.4786 2.63489Z"
      fill="currentColor"
    />
  ),
});

/** Timeline-block icon for SOURCE. */
export const ScheduleDisplaySourceIcon = createIcon({
  displayName: 'ScheduleDisplaySourceIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M14.25 21H8V19H14.25V21ZM17.2422 7.69629C17.5351 7.4034 18.0108 7.4034 18.3037 7.69629C18.5966 7.98918 18.5966 8.46492 18.3037 8.75781L14.8105 12.25H22C22.4142 12.25 22.75 12.5858 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75H14.8105L18.3037 17.2422C18.5966 17.5351 18.5966 18.0108 18.3037 18.3037C18.0108 18.5966 17.5351 18.5966 17.2422 18.3037L12.4697 13.5303C12.1768 13.2374 12.1768 12.7626 12.4697 12.4697L17.2422 7.69629ZM20.25 4C21.2165 4 22 4.7835 22 5.75V11H20V6H4V16H14V18H3.75C2.7835 18 2 17.2165 2 16.25V5.75C2 4.7835 2.7835 4 3.75 4H20.25Z"
      fill="currentColor"
    />
  ),
});

/** PLAYLIST, used both in the legend and on the timeline. */
export const SchedulePlaylistIcon = createIcon({
  displayName: 'SchedulePlaylistIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M7 2V22M17 2V22M2 12H22M2 7H7M2 17H7M17 17H22M17 7H22M4.18 2H19.82C21.024 2 22 2.97602 22 4.18V19.82C22 21.024 21.024 22 19.82 22H4.18C2.97602 22 2 21.024 2 19.82V4.18C2 2.97602 2.97602 2 4.18 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

/** The moon shown on the part of a day that has nothing scheduled. */
export const ScheduleStandbyIcon = createIcon({
  displayName: 'ScheduleStandbyIcon',
  viewBox: '0 0 16 16',
  defaultProps: { ...defaultProps, height: '4', width: '4' },
  path: (
    <path
      d="M14 8.52667C13.8951 9.66147 13.4692 10.7429 12.7722 11.6445C12.0751 12.5461 11.1357 13.2305 10.0638 13.6177C8.99194 14.0049 7.83199 14.0787 6.71967 13.8307C5.60735 13.5827 4.58866 13.023 3.78282 12.2172C2.97697 11.4113 2.41729 10.3927 2.16927 9.28033C1.92125 8.16801 1.99514 7.00806 2.38231 5.9362C2.76947 4.86434 3.45389 3.92491 4.35548 3.22784C5.25706 2.53076 6.33853 2.10487 7.47333 2C6.80894 2.89884 6.48923 4.0063 6.57236 5.12094C6.65548 6.23559 7.13591 7.28337 7.92627 8.07373C8.71663 8.86409 9.76442 9.34452 10.8791 9.42765C11.9937 9.51077 13.1012 9.19106 14 8.52667Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

/**
 * Indicates whether a day's slots are stacked in more than one priority lane.
 * Drawn rotated so the bars read horizontally, matching the design.
 */
export const ScheduleStackedIcon = createIcon({
  displayName: 'ScheduleStackedIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <g transform="rotate(90 12 12)">
      <path
        d="M6.209 12.324H4.401C3.822 12.324 3.353 12.794 3.353 13.372V20.2019C3.353 20.7799 3.823 21.2499 4.401 21.2499H6.21C6.79 21.2499 7.259 20.7799 7.259 20.2009V13.372C7.25874 13.0939 7.14813 12.8272 6.95146 12.6306C6.75479 12.4339 6.48813 12.3233 6.21 12.323M12.904 2.75H11.096C10.516 2.75 10.047 3.22 10.047 3.799V20.1999C10.047 20.7799 10.517 21.2489 11.097 21.2489H12.904C13.484 21.2489 13.953 20.7789 13.953 20.1999V3.8C13.953 3.22 13.483 2.751 12.903 2.751M19.599 2.67871H17.79C17.21 2.67871 16.741 3.14871 16.741 3.72871V14.9517C16.741 15.5317 17.211 16.0007 17.79 16.0007H19.598C19.8761 16.0004 20.1428 15.8898 20.3395 15.6932C20.5361 15.4965 20.6467 15.2298 20.647 14.9517V3.72771C20.647 3.14771 20.177 2.67871 19.597 2.67871"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});

/**
 * BRIGHTNESS, used in the legend, the time slot form badge and on the timeline
 * (Figma "ContrastBrightness"). The brightness slider inside the form uses the
 * outline sun from ~components/ui/icons/BrightnessIcon instead.
 */
export const ScheduleBrightnessIcon = createIcon({
  displayName: 'ScheduleBrightnessIcon',
  viewBox: '0 0 24 24',
  defaultProps,
  path: (
    <path
      d="M13 22H11V19H13V22ZM9.36621 18.5625L7.86621 21.1602L6.13379 20.1602L7.63379 17.5625L9.36621 18.5625ZM17.8662 20.1602L16.1338 21.1602L14.6338 18.5625L16.3662 17.5625L17.8662 20.1602ZM12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6ZM6.4375 16.3662L3.83984 17.8662L2.83984 16.1338L5.4375 14.6338L6.4375 16.3662ZM21.1602 16.1338L20.1602 17.8662L17.5625 16.3662L18.5625 14.6338L21.1602 16.1338ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V16ZM5 13H2V11H5V13ZM22 13H19V11H22V13ZM6.4375 7.63379L5.4375 9.36621L2.83984 7.86621L3.83984 6.13379L6.4375 7.63379ZM21.1602 7.86621L18.5625 9.36621L17.5625 7.63379L20.1602 6.13379L21.1602 7.86621ZM9.36621 5.4375L7.63379 6.4375L6.13379 3.83984L7.86621 2.83984L9.36621 5.4375ZM17.8662 3.83984L16.3662 6.4375L14.6338 5.4375L16.1338 2.83984L17.8662 3.83984ZM13 5H11V2H13V5Z"
      fill="currentColor"
    />
  ),
});
